<div *ngFor="let key of systemResultKeys; trackBy: trackByIndex">
  <div class="{{key.className}} result-icon">
    <app-icon iconName="circle"></app-icon><span class="result-icon__text">{{key.resultKeyText}}</span>
  </div>
</div>